import {
    ParentalControlRating,
    ProfileParentalRating,
} from 'store/user/reducer.types';

export const setParentalRating = (
    profileParentalRating: ProfileParentalRating | null,
    isChildModeEnabled: boolean,
) => {
    if (!profileParentalRating) {
        return {
            rating: isChildModeEnabled
                ? ParentalControlRating.HU12
                : ParentalControlRating.HU18_ADULT_CENSORED,
            key: isChildModeEnabled
                ? ParentalControlRating.HU12
                : ParentalControlRating.HU18_ADULT_CENSORED,
        } as ProfileParentalRating;
    }

    return profileParentalRating;
};
